/*
 * _ (underscore) for the functions that are not exported, but used inside this file only
 */
async function _getAccessToken() {
  const myHeaders = new Headers();
  myHeaders.append(
    'Authorization',
    'Basic c2NyYXRjaC1jYXJkLWNsaWVudDpzY3JhdGNoY2FyZA=='
  );

  try {
    const res = await fetch(
      `https://${process.env.CUSTOM_DOMAIN}/iam/oauth2/token?grant_type=client_credentials`,
      {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      }
    );
    const result = await res.json();

    return await result.access_token;
  } catch (error) {
    console.error(error);
  }
}

export async function getToolsList() {
  const BearerToken = await _getAccessToken();

  if (!BearerToken) {
    return;
  }
  const myHeaders = new Headers();
  myHeaders.append('Authorization', 'Bearer ' + BearerToken);

  try {
    const res = await fetch(
      `https://${process.env.CUSTOM_DOMAIN}/registry/api/v1/Tool`,
      {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      }
    );

    return await res.json();
  } catch (err) {
    return [];
  }
}
